import Vue from 'vue';

var XpProgressBar = Vue.extend({
  name: 'XpProgressBar',
  props: {
    color: {
      type: String
    },
    height: {
      type: String,
      default: '5px'
    },
    value: {
      type: Number,
      default: null
    }
  },
  render: function render(h) {
    return h('div', {
      class: 'c-xp-progress-bar',
      style: {
        height: this.height,
        color: this.color
      }
    }, [h('div', {
      class: 'c-xp-progress-bar__line'
    }), h('div', {
      class: 'c-xp-progress-bar__subline c-xp-progress-bar__subline--inc'
    }), h('div', {
      class: 'c-xp-progress-bar__subline c-xp-progress-bar__subline--dec'
    }), h('div', {
      class: 'c-xp-progress-bar__subline c-xp-progress-bar__subline--actual',
      style: "width: ".concat(this.value, "%")
    })]);
  }
});

var PageContainer = Vue.extend({
  name: 'PageContainer',
  components: {
    XpProgressBar: XpProgressBar
  },
  data: function data() {
    return {
      recordedTime: null,
      originalAllowNavAutoHide: null,
      pageRecTime: null,
      pageTime: null,
      offTime: null,
      onTime: null,
      lastTouchEnd: 0
    };
  },
  computed: {
    showNextPageLink: function showNextPageLink() {
      return this.$xp.history.nextPageId && this.$xp.content.pageData.Class !== 'XpSelectLanguage';
    },
    homeButtonEnabled: function homeButtonEnabled() {
      var isStartPage = this.$xp.content.pageData.ID === this.$xp.settings.mergedSettings.content.startPageID;

      if (!this.$xp.device.isLoan && isStartPage || this.$xp.device.isLoan && (isStartPage || !this.$xp.history.lastHomePage)) {
        return false;
      } else {
        return true;
      }
    }
  },
  created: function created() {
    this.$xp.screen.postponeDim();
    window.addEventListener('beforeunload', this.onBeforeUnload);
  },
  mounted: function mounted() {
    console.log('#*#*# PageContainer mounted [core]');
    this.startVisitRecording();

    if (this.$xp.content.pageData.isStartPage) {
      window.localStorage.removeItem('nfcLangCode');
      window.localStorage.removeItem('nfcSelectedBranchIds');
      window.localStorage.removeItem('nfcPageId');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$xp.screen.cancelDimTimer();
    this.stopVisitRecording();
    this.$xp.settings.resetSettingsState();
    this.$xp.history.resetHistoryState();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var _this = this;

    !this.$xp.navigation.isChildPagesMenuHidden && this.$xp.navigation.toggleChildPagesMenu(); // disable navigation bars animation temporary
    // .c-top-bar // transition: top .2s ease-in-out;
    // .c-page-container__back // transition: bottom .2s ease-in-out;
    // unfocus elements

    document.activeElement.blur();
    Vue.nextTick(function () {
      _this.$el.querySelector('.c-top-bar').style.transition = 'none';

      if (_this.$el.querySelector('.c-page-container__back') !== null) {
        _this.$el.querySelector('.c-page-container__back').style.transition = 'none';
      }

      setTimeout(function () {
        console.log('add top bar classes');
        _this.$el.querySelector('.c-top-bar').style.transition = 'top .2s ease-in-out';

        if (_this.$el.querySelector('.c-page-container__back') !== null) {
          _this.$el.querySelector('.c-page-container__back').style.transition = 'bottom .2s ease-in-out';
        }
      }, 500);
    });
    next();
  },
  methods: {
    goBack: function goBack(e) {
      e.preventDefault();
      this.$xp.history.back();
    },
    onFocusSr: function onFocusSr(e) {
      this.$xp.navigation.showNav();
    },
    showNavPermanent: function showNavPermanent(e) {
      e.preventDefault();
      this.$xp.navigation.preventAutoHide();
      this.$xp.navigation.showNav();
    },
    startVisitRecording: function startVisitRecording() {
      this.$xp.evaInstalled && this.$xp.eva.startVisit();
      this.recordedTime = Date.now();
    },
    stopVisitRecording: function stopVisitRecording() {
      console.log();
      this.writePageRecord(this.$xp.history.historyArray[this.$xp.history.historyArray.length - 1].pageId);
      this.$xp.evaInstalled && this.$xp.eva.endVisit();
    },
    onBeforeUnload: function onBeforeUnload() {
      this.stopVisitRecording();
    },
    writePageRecord: function writePageRecord(pageId) {
      if (!pageId) {
        // PageRec is invalid
        return;
      }

      var pageRecord = {
        start: this.pageRecTime !== null ? this.pageRecTime : this.recordedTime,
        end: Date.now(),
        langcode: this.$xp.polyglot.locale,
        on: this.onTime !== null ? this.onTime : Date.now() - (this.pageTime !== null ? this.pageTime : this.pageRecTime !== null ? this.pageRecTime : this.recordedTime),
        off: this.offTime,
        pageid: pageId
      };

      if (isNaN(pageRecord.on) || pageRecord === null) {
        pageRecord.on = pageRecord.end - pageRecord.start;
      }

      this.$xp.evaInstalled && this.$xp.eva.addPage(pageRecord);
      console.log(pageRecord);
    },
    getIconClass: function getIconClass(pageClass) {
      switch (pageClass) {
        case 'XpMenu':
          return 'xp-menu';

        case 'XpNumericInput':
          return 'xp-numpad';

        case 'XpMap':
          return 'xp-map';

        case 'XpNfc':
          return 'xp-nfc';

        case 'XpPanorama':
          return 'xp-panorama';

        default:
          return pageClass.replace(/(Xp|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
      }
    },
    selectTab: function selectTab(tabId) {
      this.$xp.navigation.setActiveTabId(tabId);
    },
    renderTabs: function renderTabs(h) {
      var _this2 = this;

      if (this.$xp.navigation.tabs.length < 2) {
        return null;
      }

      return h('ul', {
        class: {
          'o-nav-tabs': true,
          'o-nav-tabs--hidden': this.$xp.navigation.isNavHidden
        }
      }, [this.$xp.navigation.tabs.map(function (item) {
        return h('li', {
          class: {
            'o-nav-tabs__tab': true,
            'is-active': _this2.$xp.navigation.activeTabId === item.ID
          },
          key: item.ID
        }, [h('a', {
          attrs: {
            title: item.Title,
            tabindex: '0',
            role: 'button'
          },
          class: 'o-nav-tabs__tab-a',
          on: {
            click: function click(e) {
              e.preventDefault();

              _this2.selectTab(item.ID);
            }
          }
        }, [h('span', {
          class: "xp xp--large ".concat(_this2.getIconClass(item.Class))
        })])]);
      })]);
    },
    renderTopBar: function renderTopBar(h) {
      var _this3 = this;

      return h('div', {
        class: {
          'c-top-bar': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        attrs: {
          'aria-expanded': this.$xp.navigation.isNavHidden
        }
      }, [h('div', {
        'class': ['c-top-bar__nav-wrapper']
      }, [this.homeButtonEnabled ? h('button', {
        attrs: {
          'aria-label': this.$xp.history.lastHomePage ? "".concat(this.$t('global.backHome'), " ").concat(this.$xp.history.lastHomePage.title) : this.$t('global.homePageBtnLabel'),
          'role': 'link'
        },
        class: {
          'c-top-bar__button': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        on: {
          click: function click() {
            return _this3.$xp.history.goHome();
          }
        }
      }, [h('span', {
        class: 'xp xp-home xp--large link'
      })]) : null, h('h1', {
        class: 'c-top-bar__heading js-heading'
      }, [h('span', {
        class: 'c-top-bar__heading-text js-heading-text'
      }, [this.$xp.content.pageTitle])]), // <button href="#" @click="$xp.navigation.toggleChildPagesMenu()" class="c-top-bar__button right" :aria-expanded="$xp.navigation.isChildPagesMenuHidden ? 'false':'true'" :aria-label="$t('global.openChildPagesMenu')" v-if="$xp.navigation.childPagesMenuItems.length > 0 && $xp.content.pageData.Class !== 'XpMenu'">
      //     <span class="xp xp-menu xp--large link"></span>
      // </button>
      this.$xp.navigation.childPagesMenuItems.length > 0 && this.$xp.content.pageData.Class !== 'XpMenu' && this.$xp.settings.mergedSettings.navigation.showChildPagesMenu ? h('button', {
        attrs: {
          href: '#',
          'aria-expanded': this.$xp.navigation.isChildPagesMenuHidden,
          'aria-label': this.$t('global.openChildPagesMenu')
        },
        class: {
          'c-top-bar__button': true,
          'right': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        on: {
          click: function click() {
            _this3.$xp.navigation.toggleChildPagesMenu();
          }
        }
      }, [h('span', {
        class: 'xp xp-menu xp--large link'
      })]) : null, // <router-link tag="button" :aria-label="$t('global.nextPageBtnLabel')" :class="$xp.navigation.isNavHidden ? 'c-top-bar__button right is-hidden' : 'c-top-bar__button right'" role="link" v-show="showNextPageLink" :to="'/page/' + $xp.history.nextPageId">
      //   <span class="xp xp-arrow-forward xp--large link"></span>
      // </router-link>
      this.showNextPageLink ? h('router-link', {
        attrs: {
          'aria-label': this.$t('global.nextPageBtnLabel'),
          role: 'link'
        },
        class: {
          'c-top-bar__button': true,
          'right': true,
          'is-hidden': this.$xp.navigation.isNavHidden
        },
        props: {
          tag: 'button',
          to: "/page/".concat(this.$xp.history.nextPageId)
        }
      }, [h('span', {
        class: 'xp xp-arrow-forward xp--large link'
      })]) : null])]);
    }
  },
  watch: {
    '$xp.screen.isIdle': {
      handler: function handler(newValue, oldValue) {
        console.log('oldvalue', oldValue, 'newValue', newValue);

        if (newValue === true) {
          if (this.onTime === null) {
            this.onTime = Date.now() - this.pageTime;
          } else {
            this.onTime += Date.now() - this.pageTime;
          }

          if (this.offTime === null) {
            this.offTime = 0;
          }

          this.pageTime = Date.now();
        }

        if (newValue === false) {
          if (this.offTime === null) {
            this.offTime = Date.now() - this.pageTime;
          } else {
            this.offTime += Date.now() - this.pageTime;
          }

          if (this.onTime === null) {
            this.onTime = 0;
          }

          this.pageTime = Date.now();
        }
      }
    },
    '$xp.content.pageTitle': {
      handler: function handler(newValue, oldValue) {
        var _this4 = this;

        // console.log(document.title)
        // console.log(this.$refs['title'])
        var span = this.$el.querySelector('.js-heading-text');
        span.classList.remove('c-top-bar__heading-text--marquee');
        setTimeout(function () {
          var heading = _this4.$el.querySelector('.js-heading');

          if (heading.offsetWidth < span.offsetWidth) {
            console.log("overflowed by ".concat(heading.offsetWidth - span.offsetWidth, " px"));
            span.classList.add('c-top-bar__heading-text--marquee');
            var duration = Math.round(span.offsetWidth / 80, 1);
            span.style.animationDuration = duration + 's';
            var delay = Math.round(Math.min(span.offsetWidth / 500, (span.offsetWidth - heading.offsetWidth) / 160), 1);
            span.style.animationDelay = '-' + delay + 's';
          } else {
            span.classList.remove('c-top-bar__heading-text--marquee');
          }
        }, 200);

        if (newValue === undefined) {
          this.writePageRecord(this.$route.params.id);
          this.onTime = null;
          this.offTime = null;
          this.pageTime = this.pageRecTime = Date.now();
        }

        if (newValue !== undefined) {
          if (this.$xp.device.platform === 'ios') {
            if (window.StatusBar.isVisible) {
              window.StatusBar.hide();
              console.log('is it not responding ?');
            }

            console.log('statusbar', window.StatusBar);
            console.log('visibility', window.StatusBar.isVisible);
          } // console.log(newValue)

        }

        console.log('current Page :', newValue, 'last Page:', oldValue);
      }
    },
    '$xp.navigation.isNavHidden': {
      handler: function handler(value) {
        if (value === true) {
          !this.$xp.navigation.isChildPagesMenuHidden && this.$xp.navigation.toggleChildPagesMenu();
        }
      }
    },
    '$xp.navigation.isChildPagesMenuHidden': function $xpNavigationIsChildPagesMenuHidden(v) {
      if (this.originalAllowNavAutoHide === null) {
        this.originalAllowNavAutoHide = this.$xp.navigation.isAutoHideAllowed;
      }

      if (!v && this.originalAllowNavAutoHide) {
        this.$xp.navigation.preventAutoHide();
        this.$xp.navigation.showNav();
      } else {
        if (this.originalAllowNavAutoHide) {
          this.$xp.navigation.allowAutoHide();
          this.$xp.navigation.showNav(500);
        }

        this.originalAllowNavAutoHide = null;
      }

      this.$xp.history.setHistoryParam(this.$route.params.id, 'lastChildPagesState', v);
    },
    '$xp.settings.mergedSettings.exitAppNow': {
      handler: function handler(v) {
        console.log('exit app now');

        if (v && this.$xp.device.platform === 'android') {
          window.XpedeoPreloader.disableKioskAndExit();
        }
      }
    }
  },
  render: function render(h) {
    var _this5 = this;

    return h('div', {
      'class': ['c-page-container']
    }, [this.renderTopBar(h), this.renderTabs(h), // <div role="main" :class="{'c-page-container__content': true, 'js-page-content': true}">
    //   <dynamic-page :key="$route.fullPath" :pageData="$xp.content.pageData"></dynamic-page>
    // </div>
    h('div', {
      attrs: {
        role: 'main'
      },
      class: 'c-page-container__content js-page-content'
    }, [h('dynamic-page', {
      props: {
        pageData: this.$xp.content.pageData
      },
      key: this.$route.fullPath
    })]), // <a href="#" :aria-label="$t('global.back')" v-show="$xp.history.historyArray.length > 1" :class="$xp.navigation.isNavHidden ? 'c-page-container__back is-hidden':'c-page-container__back'" @click.prevent="goBack" tabindex="0">
    //   <span class="xp xp-arrow-back xp--large link"></span>
    // </a>
    this.$xp.history.historyArray.length > 1 ? h('a', {
      attrs: {
        href: '#',
        'aria-label': this.$t('global.back'),
        tabindex: 0
      },
      class: {
        'c-page-container__back': true,
        'is-hidden': this.$xp.navigation.isNavHidden
      },
      on: {
        click: this.goBack
      }
    }, [h('span', {
      class: 'xp xp-arrow-back xp--large link'
    })]) : null, // <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutRight" :duration="200">
    //   <div class="c-page-container__child-pages" v-if="!$xp.navigation.isChildPagesMenuHidden" @blur="$xp.navigation.toggleChildPagesMenu()">
    //     <ul>
    //       <router-link tag="li" :to="'/page/' + item.id" v-for="item in $xp.navigation.childPagesMenuItems" :key="item.id">
    //         {{ item.title }}
    //       </router-link>
    //     </ul>
    //   </div>
    // </transition>
    this.$xp.settings.mergedSettings.navigation.showChildPagesMenu ? h('transition', {
      props: {
        'enter-active-class': 'animated fadeInRight',
        'leave-active-class': 'animated fadeOutRight',
        duration: 100
      },
      attrs: {
        style: {
          'animation-duration': '.1s'
        }
      }
    }, [!this.$xp.navigation.isChildPagesMenuHidden ? h('div', {
      class: 'c-page-container__child-pages',
      on: {
        click: function click() {
          return _this5.$xp.navigation.toggleChildPagesMenu();
        }
      }
    }, [h('ul', {}, this.$xp.navigation.childPagesMenuItems.map(function (item) {
      return h('router-link', {
        props: {
          tag: 'li',
          to: "/page/".concat(item.id)
        },
        key: item.id
      }, [item.title]);
    }))]) : null]) : null, // progress bar infinite animation causing problems with TalkBack.
    // Therfore, it should be removed from DOM when it's not needed
    this.$xp.http.isLoading ? h('xp-progress-bar', {
      props: {
        value: this.$xp.http.progressValue
      },
      class: {
        'c-page-container__progress': true // 'c-page-container__progress--hidden': !this.$xp.http.isLoading

      }
    }) : null]);
  }
});

export default PageContainer;
